import { add, intervalToDuration } from 'date-fns';
import type { Duration } from 'date-fns';

/**
 * Adds one duration to another and returns summ
 * @param duration1 Duration
 * @param duration2 Duration
 * @returns Duration
 * @link https://github.com/date-fns/date-fns/issues/2253#issuecomment-1737596439
 */
export const addDurations = (duration1: Duration, duration2: Duration) => {
  const baseDate = new Date(0); // can probably be any date, 0 just seemed like a good start

  return intervalToDuration({
    start: baseDate,
    end: add(add(baseDate, duration1), duration2),
  });
};
